export interface IState {
  ScheduleTaskData: any;
  crewTaskAssingee: any;
  holidayList: any;
  schedulePtoList: any;
  ScheduleCashFlowData: any;
  scheduleWorkorderList: any;
  scheduleWorkLoadData: any;
  scheduleBeyListData: any;
}

type Action = any;

export const scheduleReducer = (
  state: IState = {
    ScheduleTaskData: [],
    crewTaskAssingee: [],
    holidayList: [],
    schedulePtoList: [],
    ScheduleCashFlowData: [],
    scheduleWorkorderList: [],
    scheduleWorkLoadData: [],
    scheduleBeyListData: [],
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_SCHEDULE_TASK":
      return {
        ...state,
        ScheduleTaskData:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.ScheduleTaskData, ...action?.payload?.data],
      };

    case "ASSIGNEE_ADDED_OPEN_TASK":
      return {
        ...state,
        ScheduleTaskData: state?.ScheduleTaskData?.filter((item: any) => item?._id != action?.payload),
      };

    case "GET_SCHEDULE_ASSINGEE_TASK":
      return {
        ...state,
        crewTaskAssingee:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.crewTaskAssingee, ...action?.payload?.data],
      };
    case "DRAG_AND_DROP_TASK":
      const assignees = action?.payload?.task?.assigned?.map((elem: any) => elem?._id);
      return {
        ...state,
        ScheduleTaskData: state?.ScheduleTaskData?.map((item: any) =>
          item?._id == action?.payload?.task?._id ? action?.payload?.task : item
        ),
        crewTaskAssingee: state?.crewTaskAssingee?.map((elem: any) => {
          if (elem?._id == action?.payload?.userId) {
            return { ...elem, tasks: [...elem?.tasks, { ...action?.payload?.task, assigned: assignees }] };
          }
          return elem;
        }),
      };
    case "REMOVE_TASK_TO_ASSIGNEE":
      return {
        ...state,
        ScheduleTaskData: state?.ScheduleTaskData?.map((item: any) =>
          item?._id == action?.payload?.task?._id ? action?.payload?.task : item
        ),
        crewTaskAssingee: state?.crewTaskAssingee?.map((elem: any) => {
          if (elem?._id == action?.payload?.userId) {
            return { ...elem, tasks: elem?.tasks?.filter((el: any) => el?._id != action?.payload?.task?._id) };
          }
          return elem;
        }),
      };

    case "GET_HOLIDAY":
      return {
        ...state,
        holidayList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.holidayList, ...action?.payload?.data],
      };
    case "EDIT_HOLIDAY_DATA":
      return {
        ...state,
        holidayList: state?.holidayList?.map((item: any) =>
          item?._id == action?.payload?._id ? action?.payload : item
        ),
      };
    case "DELETE_HOLIDAY_DATA":
      return {
        ...state,
        holidayList: state?.holidayList?.filter((item: any) => item?._id != action?.payload),
      };
    case "GET_SCHEDULE_PTO":
      return {
        ...state,
        schedulePtoList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.schedulePtoList, ...action?.payload?.data],
      };
    case "EDIT_PTO_DATA":
      return {
        ...state,
        schedulePtoList: state?.schedulePtoList?.map((item: any) =>
          item?._id == action?.payload?._id ? action?.payload : item
        ),
      };
    case "DELETE_PTO_DATA":
      return {
        ...state,
        schedulePtoList: state?.schedulePtoList?.filter((item: any) => item?._id != action?.payload),
      };
    case "GET_SCHEDULE_CASH_FLOW":
      return {
        ...state,
        ScheduleCashFlowData: action?.payload,
      };

    case "GET_SCHEDULE_WORK_ORDERS":
      return {
        ...state,
        scheduleWorkorderList:
          action?.payload?.page == 1
            ? action?.payload?.data
            : [...state?.scheduleWorkorderList, ...action?.payload?.data],
      };

    case "GET_SCHEDULE_WORK_LOAD":
      return {
        ...state,
        scheduleWorkLoadData: action?.payload,
      };

    case "WORK_ORDER_DAY_PLAN_UPDATE":
      return {
        ...state,
        scheduleWorkorderList: state?.scheduleWorkorderList?.map((elem: any) =>
          elem?._id == action?.payload?._id
            ? {
                ...elem,
                allow_saturday_worked: action?.payload?.allow_saturday_worked,
                allow_sunday_worked: action?.payload?.allow_sunday_worked,
                working_hr: action?.payload?.working_hr,
              }
            : elem
        ),
      };

    case "GET_SCHEDULE_BEY_LIST":
      return {
        ...state,
        scheduleBeyListData: action?.payload,
      };

    case "ADD_ASSIGNEE_IN_TASK":
      return {
        ...state,
        ScheduleTaskData: state?.ScheduleTaskData?.map((elem: any) =>
          elem?._id == action?.payload?._id ? action?.payload : elem
        ),
      };

    default:
      return state;
  }
};
